export let IframeOnloadDirective = () => ({
  scope: {
    callBack: '&iframeOnload',
  },
  link: (scope, elem) => {
    elem.on('load', () => scope.callBack(elem));

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
      elem.off('load');
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  },
});

export default 'iframeOnload';
